/*
  Puts the cart drawer's order summary where it belongs.

  The drawer is built as a scrolling item list (.cart-drawer__items) above a
  pinned footer (.cart-drawer__summary) that holds the totals and Check out.
  The Knott summary is rendered by snippets/knott-cart-offers.liquid, which the
  theme prints inside the SCROLLING half — so the breakdown sat somewhere up in
  the item list while "Estimated total" was repeated down by the button.

  The fix belongs in cart-summary.liquid, but that file is 20.6KB and a single
  theme-file write is capped below that, so the summary is moved here instead:
  one node, into the pinned footer, above the Check out button.

  The drawer re-renders its own markup every time a quantity changes or a line
  is removed, which puts the summary back in the scrolling half, so the move is
  reapplied whenever the drawer's contents change.
*/
(function () {
  if (window.__knottCartLayout) return;
  window.__knottCartLayout = true;

  var SUMMARY = '[data-kb-sum]';
  var FOOTER = '.cart-drawer__summary';

  function place() {
    var drawers = document.querySelectorAll('cart-drawer-component');

    for (var i = 0; i < drawers.length; i++) {
      var summary = drawers[i].querySelector(SUMMARY);
      var footer = drawers[i].querySelector(FOOTER);

      /* No footer means the cart PAGE, where the summary is already in the
         right place and must be left alone. */
      if (!summary || !footer) continue;

      /* Already placed. Returning early is what stops the observer below from
         reacting to its own move. */
      if (summary.parentElement === footer && footer.firstElementChild === summary) continue;

      footer.insertBefore(summary, footer.firstElementChild);
    }
  }

  function watch() {
    place();

    var drawer = document.querySelector('cart-drawer-component');
    var root = drawer || document.body;

    new MutationObserver(place).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();